import classnames from 'classnames/bind';
import Input from 'components/Input';
import Typography from 'components/Typography';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import styles from './CreateClass.module.scss';

const cx = classnames.bind(styles);

const CreateClass = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Typography type="h4">Create a Class</Typography>

      <Typography className={cx('description', 'mgt-15', 'mgb-25')}>
        You can name your class anything you want.{' '}
      </Typography>

      <Input label="Class Name" name="className" inputRef={register('className', { required: true })} errors={errors} />
    </>
  );
};

export default CreateClass;
